import { render } from "./SignUpTemplate.vue?vue&type=template&id=3c8ab784&scoped=true"
import script from "./SignUpTemplate.vue?vue&type=script&lang=js"
export * from "./SignUpTemplate.vue?vue&type=script&lang=js"

import "./SignUpTemplate.vue?vue&type=style&index=0&id=3c8ab784&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8ab784"]])

export default __exports__